jQuery(document).ready(function($){
    $('a[href^="#"]').on('click', function(e){
        const element = $( $(this).attr('href') );
        
        if (element.length > 0) {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: element.offset().top - 100
            }, 800);
        }
    });

    $('.back-to-top').on('click', function(e){
        e.preventDefault();

        $('html, body').animate({
            scrollTop: 0
        }, 800);
    });
});